import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "gallery" };
const _hoisted_2 = { class: "gallery__header" };
const _hoisted_3 = { class: "gallery__label" };
const _hoisted_4 = { class: "gallery__title" };
const _hoisted_5 = { class: "gallery__categories" };
const _hoisted_6 = { class: "category-card__media" };
const _hoisted_7 = ["src", "alt"];
const _hoisted_8 = { class: "category-card__meta" };
const _hoisted_9 = { class: "category-card__tagline" };
const _hoisted_10 = { class: "category-card__label" };
const _hoisted_11 = { class: "gallery__header" };
const _hoisted_12 = { class: "gallery__label" };
const _hoisted_13 = { class: "gallery__title" };
const _hoisted_14 = { class: "gallery__grid" };
const _hoisted_15 = ["onClick"];
const _hoisted_16 = { class: "album-card__media" };
const _hoisted_17 = ["src", "alt"];
const _hoisted_18 = { class: "album-card__meta" };
const _hoisted_19 = { class: "album-card__place" };
const _hoisted_20 = { class: "album-card__title" };
const _hoisted_21 = { class: "album-page__header" };
const _hoisted_22 = { class: "album-page__heading" };
const _hoisted_23 = { class: "album-page__title" };
const _hoisted_24 = { class: "album-page__meta" };
const _hoisted_25 = {
    key: 0,
    class: "album-page__desc"
};
const _hoisted_26 = { class: "album-page__masonry" };
const _hoisted_27 = ["onClick"];
const _hoisted_28 = ["src", "alt"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    const _component_AlbumViewer = _resolveComponent("AlbumViewer");
    return (_openBlock(), _createElementBlock("section", _hoisted_1, [
        (_ctx.selectedCategory === null)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("header", _hoisted_2, [
                    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('portfolio.label')), 1),
                    _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('portfolio.title')), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (cat) => {
                        return (_openBlock(), _createBlock(_component_router_link, {
                            key: cat.value,
                            to: _ctx.localizedTo('portfolio-category', { category: cat.value }),
                            class: "category-card"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("img", {
                                        src: cat.image,
                                        alt: cat.label,
                                        loading: "lazy"
                                    }, null, 8, _hoisted_7),
                                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "category-card__scrim" }, null, -1))
                                ]),
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("p", _hoisted_9, _toDisplayString(cat.tagline), 1),
                                    _createElementVNode("p", _hoisted_10, _toDisplayString(cat.label), 1)
                                ])
                            ]),
                            _: 2
                        }, 1032, ["to"]));
                    }), 128))
                ])
            ], 64))
            : (_ctx.albumIndex === null)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("header", _hoisted_11, [
                        _createVNode(_component_router_link, {
                            to: _ctx.localizedTo('portfolio'),
                            class: "gallery__back"
                        }, {
                            default: _withCtx(() => [
                                _cache[3] || (_cache[3] = _createElementVNode("svg", {
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "1.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "aria-hidden": "true"
                                }, [
                                    _createElementVNode("polyline", { points: "15 6 9 12 15 18" })
                                ], -1)),
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('portfolio.backLabel')), 1)
                            ]),
                            _: 1
                        }, 8, ["to"]),
                        _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('portfolio.label')), 1),
                        _createElementVNode("h1", _hoisted_13, _toDisplayString(_ctx.activeCategoryLabel), 1)
                    ]),
                    _createElementVNode("ul", _hoisted_14, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAlbums, (entry) => {
                            return (_openBlock(), _createElementBlock("li", {
                                key: entry.album.title,
                                class: "gallery__item"
                            }, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "album-card",
                                    onClick: ($event) => (_ctx.openAlbum(entry.flatIndex))
                                }, [
                                    _createElementVNode("div", _hoisted_16, [
                                        _createElementVNode("img", {
                                            src: entry.album.cover,
                                            alt: `${entry.album.title}, ${entry.album.place}, ${_ctx.$t('portfolio.categoryLabels.' + entry.album.category)}`,
                                            loading: "lazy"
                                        }, null, 8, _hoisted_17),
                                        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "album-card__scrim" }, null, -1))
                                    ]),
                                    _createElementVNode("div", _hoisted_18, [
                                        _createElementVNode("p", _hoisted_19, _toDisplayString(entry.album.place), 1),
                                        _createElementVNode("p", _hoisted_20, _toDisplayString(entry.album.title), 1)
                                    ])
                                ], 8, _hoisted_15)
                            ]));
                        }), 128))
                    ])
                ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("header", _hoisted_21, [
                        _createElementVNode("button", {
                            type: "button",
                            class: "album-page__back",
                            onClick: _cache[0] || (_cache[0] =
                                //@ts-ignore
                                (...args) => (_ctx.backToList && _ctx.backToList(...args)))
                        }, [
                            _cache[5] || (_cache[5] = _createElementVNode("svg", {
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "1.5",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "aria-hidden": "true"
                            }, [
                                _createElementVNode("polyline", { points: "15 6 9 12 15 18" })
                            ], -1)),
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('portfolio.backLabel')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("h1", _hoisted_23, _toDisplayString(_ctx.activeAlbum?.title), 1),
                            _createElementVNode("p", _hoisted_24, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.activeAlbum?.place), 1),
                                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "album-page__dot" }, "·", -1)),
                                _createElementVNode("span", null, _toDisplayString(_ctx.activeAlbum?.photos.length) + " " + _toDisplayString(_ctx.$t('portfolio.photoCount')), 1)
                            ]),
                            (_ctx.activeAlbum?.description)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_ctx.activeAlbum.description), 1))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeAlbum?.photos, (src, idx) => {
                            return (_openBlock(), _createElementBlock("button", {
                                key: src,
                                type: "button",
                                class: "album-page__tile",
                                onClick: ($event) => (_ctx.openPhoto(idx))
                            }, [
                                _createElementVNode("img", {
                                    src: src,
                                    alt: `${_ctx.activeAlbum?.title} ${idx + 1}`,
                                    loading: "lazy",
                                    onLoad: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.onTileLoad && _ctx.onTileLoad(...args)))
                                }, null, 40, _hoisted_28)
                            ], 8, _hoisted_27));
                        }), 128))
                    ])
                ], 64)),
        (_ctx.activeAlbum && _ctx.viewerStart !== null)
            ? (_openBlock(), _createBlock(_component_AlbumViewer, {
                key: 3,
                album: _ctx.activeAlbum,
                "initial-index": _ctx.viewerStart,
                "close-label": _ctx.$t('portfolio.closeLabel'),
                "prev-label": _ctx.$t('portfolio.prevLabel'),
                "next-label": _ctx.$t('portfolio.nextLabel'),
                "photo-count-label": _ctx.$t('portfolio.photoCount'),
                onClose: _ctx.closeViewer
            }, null, 8, ["album", "initial-index", "close-label", "prev-label", "next-label", "photo-count-label", "onClose"]))
            : _createCommentVNode("", true)
    ]));
}
